// extracted by mini-css-extract-plugin
export var table = "_wh-0";